import React from "react";
import { useTranslation } from "react-i18next";
import { Modal, ModalHeader } from "reactstrap";
import { StyledH2 } from "@aureskonnect/react-ui";
import { useSnapshot } from "valtio";

import { store } from "@pages/SettingGeneral/Language/store";
import {
    store as settingPrinter,
    setIsSettingModalOpened,
    setIsSettingFromPrinter,
} from "../store";
import { setIsConfigurationPrinterClicked } from "../../../Applications/Kiosk/store";
import { resetStore as resetStoreCustomer } from "../../../ApplicationSetting/CustomerTicket/Hook/store";
import { resetStore as resetStoreKitchenTicket } from "../../../ApplicationSetting/KitchenTicket/Hook/store";
import { resetStore as resetStoreDivers } from "../../../ApplicationSetting/Divers/Hook/store";
import { resetStore as resetStoreModelTicket } from "../../../ApplicationSetting/ModeleTicket/store";
import {
    store as configStore,
    setPrinterConfigModalOpened,
} from "@pages/ApplicationSetting/store";
import { setTypeLogoCustomer } from "../../../ApplicationSetting/General/Hook/store";

import { capitalize } from "@helpers/general";
import { MenuWrapper } from "@pages/Applications/MenuWrapperConfiguration";
import { PrinterConfigModal } from "@pages/ApplicationSetting/PrinterConfigModal";

import "@assets/swal.css";
import "@assets/theme.css";
import "./index.css";

type PrinterSettingType = {
    oneShop?: any;
    setDataIsUpdated: Function;
};

export default function PrinterSetting({
    oneShop,
    setDataIsUpdated,
}: PrinterSettingType) {
    const { t } = useTranslation();
    const { isSettingModalOpened } = useSnapshot(settingPrinter);
    const { shopRowData } = useSnapshot(store);
    const { printerConfigModalOpened } = useSnapshot(configStore);

    return (
        <Modal
            centered
            backdrop="static"
            fade={false}
            scrollable
            className="modal-wrapper-width__clz"
            isOpen={isSettingModalOpened}
        >
            <ModalHeader
                toggle={() => {
                    setIsSettingFromPrinter(false);
                    setIsConfigurationPrinterClicked(false);
                    setPrinterConfigModalOpened(false);
                    resetStoreCustomer();
                    resetStoreKitchenTicket();
                    resetStoreDivers();
                    resetStoreModelTicket();
                    setIsSettingModalOpened(false);
                    setTypeLogoCustomer("");
                }}
            >
                <StyledH2>
                    {capitalize(t("Print setting"))}-
                    {t(shopRowData[t("Printer name") as any])}
                </StyledH2>
            </ModalHeader>
            <MenuWrapper rowData={shopRowData} oneShop={oneShop} />
            {printerConfigModalOpened ? <PrinterConfigModal /> : null}
        </Modal>
    );
}
